<template>
	<div class="flex flex-row justify-content-between align-items-center m-2 bg-grey">
		<div class="flex flex-row align-items-center">
			<div class="pi pi-circle-fill text-xs mr-2" />
			<span class="mr-2">Toast message position:</span>
			<PSelectButton
				:allowEmpty="false"
				:options="vOptions"
				@click="save()"
				aria-labelledby="basic"
				v-model="vPosition"
			/>
			<span class="mx-2">/</span>
			<PSelectButton
				:allowEmpty="false"
				:options="hOptions"
				@click="save()"
				aria-labelledby="basic"
				v-model="hPosition"
			/>
		</div>
		<!-- <PButton
			label="Save"
			text
		/>-->
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import Constants from '@/helpers/Constants'
	import PB from '@/brokers/PersistencyBroker'
	import Utils from '@/utils/Utils'
	import EventBus from '@/utils/EventBus'

	export default defineComponent({
		components: {
		},

		data() {
			return {
				before: '',
				position: 'bottom-right',
				vPosition: 'bottom',
				hPosition: 'center',
				vOptions: [
					'top',
					'bottom',
				],
				hOptions: [
					'left',
					'center',
					'right',
				],
			}
		},

		created() {
			const position = PB.get(Constants.LOCAL_STORAGE_IDS.TOAST_POSITION)
			if (position) {
				this.vPosition = position.split('-')[0]
				this.hPosition = position.split('-')[1]
				this.position = position
				this.before = this.position
			}
		},

		methods: {
			save() {
				this.position = this.vPosition + '-' + this.hPosition
				if (this.position != this.before) {
					PB.set(Constants.LOCAL_STORAGE_IDS.TOAST_POSITION, this.position)
					EventBus.emit(Constants.EVENTS.SET_TOAST_POSITION, this.position)
					Utils.showSuccessMessage('Settings have been saved succcessfully.')
					this.before = this.position
				}
			}
		}
	})
</script>

<style scoped>
</style>
